import { useNavigate } from 'react-router-dom'

import Button from 'src/ui/atoms/Button'
import { IProject } from './useProjectApi'

const NFTProject = ({ project }: { project: IProject }) => {
  let chain = project.data.chain
  let network = project.data.network
  let status = project.status
  let detailedTokenTicker = project.data.detailedTokenTicker
  let scAddress = project.scAddress

  const navigate = useNavigate()
  const roleUrl = `/nft-set-role?chain=${chain.toUpperCase()}&network=${network}&tokenIdentifier=${detailedTokenTicker}`
  const mintNFTUrl = `/mint-nft?chain=${chain.toUpperCase()}&network=${network}&${
    chain === 'multiversx'
      ? 'tokenIdentifier=' + (detailedTokenTicker || '')
      : 'scAddress=' + (scAddress || '')
  }`

  return (
    <div className="grid gap-4">
      <h2 className="text-white">Actions</h2>
      <div className="flex justify-between gap-4">
        {status === 'verified' && (
          <Button name="Mint NFT" size="M" onClick={() => navigate(mintNFTUrl)} />
        )}
        {chain === 'multiversx' && (
          <Button name="Set roles" size="M" onClick={() => navigate(roleUrl)} />
        )}
      </div>
    </div>
  )
}

export default NFTProject
